import React from 'react';

interface ImageProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'alt'> {
  lazyload?: boolean;
  alt?: string | null;
}

export const Image = ({ className, src, alt, lazyload, ...props }: ImageProps) => {
  // Light blue svg rect that is used as placeholder when lazyloading
  const placeholder =
    'data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQ0IDMxNyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBmaWxsPSIjZjFmM2Y2IiBkPSJNMCAwaDI0NHYzMTdIMHoiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4K';

  return (
    <img
      className={className}
      alt={alt ?? undefined}
      src={lazyload ? placeholder : src}
      data-src={lazyload ? src : undefined}
      loading={props.loading ? props.loading : lazyload ? 'lazy' : undefined}
      {...props}
    />
  );
};
